import { render } from "./TablePorts.vue?vue&type=template&id=441fa54d&scoped=true"
import script from "./TablePorts.vue?vue&type=script&lang=js"
export * from "./TablePorts.vue?vue&type=script&lang=js"

import "./TablePorts.vue?vue&type=style&index=0&id=441fa54d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441fa54d"]])

export default __exports__